import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { toast } from "react-toastify";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
//import { hotjar } from "react-hotjar";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";
import "simplebar/src/simplebar.css";
import "./assets/css/style.css";
import "./assets/scss/type-writer.scss";

toast.configure();

Sentry.init({
  dsn: "https://0f7a4939319641d9a166b7583446f26d@o4504326415253504.ingest.sentry.io/4504327079591936",
  integrations: [new BrowserTracing()],
  // Set tracesSampleRate to 1.0 to capture 100%  // of transactions for performance monitoring.  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});
// hotjar.initialize({ hjid: 3287834, hjsv: 6 });
const root = ReactDOM.createRoot(document.getElementById("root"));
window.userGuiding.identify("88c0fc020b3dc1104dc60b1c01d956646ae9edb6aaf67fbc");
root.render(

  <React.StrictMode>
    <HelmetProvider>
      <Sentry.ErrorBoundary>
        <App />
      </Sentry.ErrorBoundary>
    </HelmetProvider>
  </React.StrictMode>

);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
